import { Box } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import useApprovalModal from '../../../hooks/useApprovalModal';
import {
  storeSchoolKycApprovalId,
  storeSchoolKycApprovalStatus,
  storeUserKycApprovalId,
  storeUserKycApprovalStatus,
} from './UserKycApproveStore/userKycApproveSlice';
import moment from 'moment';

export const userKycListColumn = [
  { Header: 'Entity Type', accessor: 'entityType' },
  { Header: 'Approval Type', accessor: 'approvalType' },
  // {
  //   Header: 'Current value',
  //   accessor: 'currentValue',
  // },
  { Header: 'New value', accessor: 'newValue' },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Created at',
    accessor: 'createdAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { createdAt } = payload;
      return (
        <>
          <Box>{moment(createdAt).format('MMMM Do, YYYY')}</Box>
        </>
      );
    },
  },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const payload = val.cell.row.original;
      const { handleOpenApprovalModal } = useApprovalModal();
      return (
        <>
          <Box display="flex">
            <Box
              sx={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={() => {
                console.log('payload table', payload);
                dispatch(storeUserKycApprovalId(payload._id));
                dispatch(storeUserKycApprovalStatus(payload.status));
                handleOpenApprovalModal({
                  type: 'userKyc',
                  data: payload,
                });
              }}
              fontSize={14}>
              View Details
            </Box>
          </Box>
        </>
      );
    },
  },
];

export const schoolKycListColumn = [
  { Header: 'Entity Type', accessor: 'entityType' },
  { Header: 'Approval Type', accessor: 'approvalType' },
  // {
  //   Header: 'Current value',
  //   accessor: 'currentValue',
  // },
  { Header: 'New value', accessor: 'newValue' },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Created at',
    accessor: 'createdAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { createdAt } = payload;
      return (
        <>
          <Box>{moment(createdAt).format('MMMM Do, YYYY')}</Box>
        </>
      );
    },
  },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const dispatch = useDispatch();
      const payload = val.cell.row.original;
      const { handleOpenApprovalModal } = useApprovalModal();
      return (
        <>
          <Box display="flex">
            <Box
              sx={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={() => {
                console.log('payload table', payload);
                dispatch(storeSchoolKycApprovalId(payload._id));
                dispatch(storeSchoolKycApprovalStatus(payload.status));
                handleOpenApprovalModal({
                  type: 'schoolKyc',
                  data: payload,
                });
              }}
              fontSize={14}>
              View Details
            </Box>
          </Box>
        </>
      );
    },
  },
];
